import { createApp } from 'vue'
import './style.css'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'

let i18n: any | null = null;

const pinia = createPinia();
const app = createApp(App);
i18n = createI18n({
    legacy: false,  // set to false to use composable mode
    //locale: languages[0], // set locale
    //fallbackLocale: languages[0], // set fallback locale 45r 
    messages: { // set locale messages
      en: {
        mobile: {
          scan_title: 'Scan the code',
          scan_description: 'Scan the QR code to copy the saved destinations, and/or created paths to your phone!'
        }
      }
    },
    fallbackWarn: false,
    missing: () => {
      //console.warn(`Missing translation for ${key}`);
      return ''; // Return empty string if key is missing
    }
  })
app.use(i18n);
app.use(pinia);
app.mount('#app');
